import { render, staticRenderFns } from "./TicketDetail.vue?vue&type=template&id=8f4bc34c&"
import script from "./TicketDetail.vue?vue&type=script&lang=ts&"
export * from "./TicketDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports